import React from "react";
import "./TableLoader.scss";
import SkeletonLoader from "../../SkeletonLoader/SkeletonLoader";

export interface TableLoaderProps {
  className?: string;
  rows: number;
  rowHeight?: number;
  colsWidth?: number[];
  "data-testid"?: string;
  hasSelection?: boolean;
}

const TableLoader: React.FC<TableLoaderProps> = (props) => {
  const {
    rows,
    rowHeight,
    colsWidth = [300, 300, 300, 300],
    "data-testid": dataTestId,
    hasSelection = false,
  } = props;

  return (
    <tbody className={"tbody"} data-testid={`${dataTestId}-table-loader`}>
      {Array.from({ length: rows }, (row, rowindex) => (
        <tr
          key={`row-${rowindex}`}
          className={`table-loader-row ${hasSelection ? "ignore-first" : ""}`}
        >
          {colsWidth.map((col, colindex) => (
            <td
              key={`col-${colindex}`}
              className={`table-loader-td`}
              style={{
                width: `${col}px`,
                height: `${rowHeight}px`,
                minHeight: `${rowHeight}px`,
              }}
            >
              <SkeletonLoader
                height={"19px"}
                width={"100%"}
                data-testid={"table-loader"}
              />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
};

export default TableLoader;
